import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { Input } from '@/components/ui/input';
import { api } from '@/lib/utils';

export function PlanNameInput({
  value,
  onChange,
  required,
}: {
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
}) {
  const [open, setOpen] = useState(false);

  const { data } = useQuery({
    queryKey: ['plan-names'],
    queryFn: () => api<{ names: string[] }>('/api/v1/obligations/plan-names'),
  });

  const names = data?.names ?? [];
  const filtered = value.trim()
    ? names.filter((n) => n.toLowerCase().includes(value.toLowerCase()))
    : names;
  const showNew =
    value.trim().length > 0 && !names.some((n) => n.toLowerCase() === value.trim().toLowerCase());

  return (
    <div className="relative">
      <Input
        label="Plan name"
        list="plan-name-suggestions"
        placeholder="e.g. Annual Comfort Plan"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onFocus={() => setOpen(true)}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
        required={required}
        helper={showNew && value.trim() ? 'New plan — will be saved for future suggestions' : undefined}
      />
      <datalist id="plan-name-suggestions">
        {names.map((n) => (
          <option key={n} value={n} />
        ))}
      </datalist>
      {open && filtered.length > 0 && (
        <ul className="absolute z-20 mt-1 max-h-40 w-full overflow-y-auto rounded-lg border border-border bg-bg-surface py-1 shadow-dropdown">
          {filtered.slice(0, 8).map((n) => (
            <li key={n}>
              <button
                type="button"
                className="w-full px-3 py-2 text-left text-sm hover:bg-bg-subtle"
                onMouseDown={(e) => {
                  e.preventDefault();
                  onChange(n);
                  setOpen(false);
                }}
              >
                {n}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
